import Header from '../Header/Header';
import { Link } from 'react-router-dom';
import icon02 from "../../../screenassets/images/cta/02.png";
import Footer from "../../Landing/Footer/Footer";

export default function Faq() {
    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Got Questions?</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Faq</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="rts-faq-area-inner rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12 pl--140 pl_md--15 pl_sm--15">
                            <div className="accordion-area-one">
                                <h4 className="title mb--25">Some frequently asked questions</h4>
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                What is cuzysolve and how does it help students?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" >
                                            <div className="accordion-body">
                                                Cuzysolve is your all-in-one study partner for Classes 6–12. Just upload your homework question or past-paper photo and get step-by-step verified answers instantly — in more than 20 local language. Whether it’s CBSE, CHSE or WBBSE Class 6-12 math, physics, biology etc. solutions, we’ve got you covered.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" >
                                                Which boards and subjects are supported?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample" >
                                            <div className="accordion-body">
                                                We support all major boards accross all over indian state boards and central board.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingThree">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Can I get step-by-step answers for board-style numericals?
                                            </button>
                                        </h2>
                                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample" >
                                            <div className="accordion-body">
                                                Yes! Every answer is broken down step-by-step — perfect for understanding CHSE Physics numericals (verified) or BSE Odisha Class 10 math step-by-step (Odisha).
                                                We focus on clarity and correctness so you can learn how, not just what the answer is.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false"
                                                aria-controls="collapseFour">
                                                In which languages can I study?
                                            </button>
                                        </h2>
                                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                You can learn in Odia, Hindi, Marathi, Bengali or English — so your study experience matches your school medium.
                                                No more confusion between English and regional questions — we provide medium-wise board-style solutions.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingFive">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                How do I start using cuzysolve?
                                            </button>
                                        </h2>
                                        <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                Simply create a free account and get 3 solves free to test. Upload your question photo, and our AI instantly gives step-by-step verified answers.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        Learning Made Easy for <br />
                                        Every Student
                                    </h3>
                                    <Link to="/signin" className="rts-btn btn-primary">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <Footer />

        </>
    )
}
